import { render } from "./widget.vue?vue&type=template&id=17acfa3e"
import script from "./widget.vue?vue&type=script&lang=js"
export * from "./widget.vue?vue&type=script&lang=js"

import "./widget.vue?vue&type=style&index=0&id=17acfa3e&lang=scss"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__